import { render } from "./myMatches.vue?vue&type=template&id=fe8acc8c&scoped=true&ts=true"
import script from "./myMatches.vue?vue&type=script&lang=ts"
export * from "./myMatches.vue?vue&type=script&lang=ts"

import "./myMatches.vue?vue&type=style&index=0&id=fe8acc8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8acc8c"]])

export default __exports__